import React from "react";

type PaginationProps = {
  activePage: number;
  itemsCountPerPage: number;
  totalItemsCount: number;
  pageRangeDisplayed: number;
  onChange(page: number): void;
};

function clampPage(page: number, totalPages: number) {
  return Math.min(Math.max(page, 1), totalPages);
}

function getVisiblePages(activePage: number, totalPages: number, pageRangeDisplayed: number) {
  const range = Math.max(pageRangeDisplayed, 1);
  const start = Math.max(1, Math.min(activePage - Math.floor(range / 2), totalPages - range + 1));
  const end = Math.min(totalPages, start + range - 1);
  const pages: number[] = [];

  for (let page = start; page <= end; page += 1) {
    pages.push(page);
  }

  return pages;
}

export default function Pagination({
  activePage,
  itemsCountPerPage,
  totalItemsCount,
  pageRangeDisplayed,
  onChange,
}: PaginationProps) {
  if (totalItemsCount <= 0) {
    return null;
  }

  const totalPages = Math.max(1, Math.ceil(totalItemsCount / Math.max(itemsCountPerPage, 1)));
  const currentPage = clampPage(activePage, totalPages);
  const visiblePages = getVisiblePages(currentPage, totalPages, pageRangeDisplayed);

  return (
    <nav aria-label="Pagination">
      <ul className="pagination">
        <li>
          <button
            type="button"
            className="btn btn-pagination"
            aria-label="Go to previous page"
            disabled={currentPage === 1}
            onClick={() => onChange(currentPage - 1)}
          >
            {"<"}
          </button>
        </li>
        {visiblePages.map((page) => {
          const isActive = page === currentPage;

          return (
            <li key={page} className={isActive ? "active" : undefined}>
              <button
                type="button"
                className="btn btn-pagination"
                aria-current={isActive ? "page" : undefined}
                disabled={isActive}
                style={isActive ? { backgroundColor: "#eaecf3" } : undefined}
                onClick={() => onChange(page)}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li>
          <button
            type="button"
            className="btn btn-pagination"
            aria-label="Go to next page"
            disabled={currentPage === totalPages}
            onClick={() => onChange(currentPage + 1)}
          >
            {">"}
          </button>
        </li>
      </ul>
    </nav>
  );
}
